module.exports = __webpack_public_path__ + "static/image4-9ce477a45639d79b72cc7d7ba97664b8.jpg";